import { useState, useEffect } from 'react';
import axios from 'axios';
import { Megaphone, BookOpen, Anchor, Presentation, Gavel } from 'lucide-react';
import { Ligne } from './TuileAdministratif';

// Communication : livrets, carnet d'intégration et présentations PowerPoint
export const TuileCommunication = () => {
  const [livret, setLivret] = useState(null);
  const [base, setBase] = useState(null);
  useEffect(() => {
    axios.get('/livret-accueil/config').then(({ data }) => setLivret(data)).catch(() => setLivret(null));
    axios.get('/livret-base/engagements').then(({ data }) => setBase(data)).catch(() => setBase(null));
  }, []);
  return (
    <div className="rounded-2xl bg-sky-800 p-5 sm:p-6 text-white shadow-sm" data-testid="tuile-communication">
      <div className="rounded-xl bg-white/15 p-2.5 w-fit"><Megaphone className="h-6 w-6" /></div>
      <p className="mt-4 text-sm font-medium text-white/80">Communication</p>
      <div className="mt-2 space-y-2">
        {livret && (
          <Ligne to="/administratif/livret-accueil" Icone={BookOpen} label="Livret d'accueil" testId="tuile-communication-livret"
            valeur={livret.publie ? 'Publié' : livret.manquants.length ? `${livret.manquants.length} infos à compléter` : 'À publier'} />
        )}
        <Ligne to="/administratif/livret-base" Icone={Anchor} label="Carnet d'intégration" testId="tuile-communication-livret-base"
          valeur={base ? `${base.filter((s) => s.engage_le).length}/${base.length} engagements` : '…'} />
        <Ligne to="/administratif/presentation" Icone={Presentation} label="Présentation du centre" testId="tuile-communication-presentation" valeur="PowerPoint · PDF" />
        <Ligne to="/administratif/jury-plenier" Icone={Gavel} label="Jury plénier" testId="tuile-communication-jury" valeur="PowerPoint · PDF" />
      </div>
    </div>
  );
};
